import {FieldConfigurationClass} from './field-configuration.class';
import {OptionValueInterface} from './option-value.interface';

export class FieldConfigurationData<T> extends FieldConfigurationClass {
  dataList?: OptionValueInterface<T>[];
  defaultItemIndex: number;
}
